/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import en from '../locales/en.json';
import uk from '../locales/uk.json';
import de from '../locales/de.json';
import el from '../locales/el.json';
import it from '../locales/it.json';
import he from '../locales/he.json';
import pl from '../locales/pl.json';
import nl from '../locales/nl.json';
import fr from '../locales/fr.json';
import pt from '../locales/pt.json';
import tr from '../locales/tr.json';
import es from '../locales/es.json';
import ja from '../locales/ja.json';

interface IReplacerType {
  pattern: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replacer: any;
}

const MESSAGES_ALL = {
  en,
  uk,
  de,
  el,
  it,
  he,
  pl,
  nl,
  fr,
  pt,
  tr,
  es,
  ja,
};

export type TSupportedMessagesType = keyof typeof MESSAGES_ALL;

export class Localization {
  private locale: string;

  private bundle: Record<string, string>;

  constructor() {
    const language = window.navigator.language.slice(0, 2).toLowerCase();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.setLocale(language as any);
  }

  setLocale = (locale?: TSupportedMessagesType) => {
    this.locale = locale && MESSAGES_ALL[locale] ? locale : 'en';
    this.bundle = MESSAGES_ALL[this.locale];
  };

  getLocale = () => this.locale;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getString(id: string, replacer?: IReplacerType): string | any[] {
    const value = this.bundle[id];

    if (!value) {
      return '';
    }

    if (!replacer) {
      return value;
    }

    const splitted = value.split(replacer.pattern);

    if (splitted.length > 1) {
      return [
        splitted[0],
        replacer.replacer,
        splitted[1],
      ];
    }

    return value;
  }
}

export const l10n = new Localization();
export const getString = l10n.getString.bind(l10n);
